import React, { FC } from 'react';
import Router from 'next/router';
import { StickyFooter } from '@/StickyFooter';
import ErrorLayout from '../layouts/Error.layout';
import Button from '@/components/Button';

interface IError404Props {}

const Error404: FC<IError404Props> = () => (
  <ErrorLayout
    description="احتمالا این صفحه به آدرس دیگری تغییر کرده."
    title="صفحه مورد نظر یافت نشد!"
    type={404}
  >
    <StickyFooter>
      <Button
        className="mt-auto"
        variant="default"
        isFullWidth
        onClick={() => Router.replace('/')}
      >
        بازگشت به خانه
      </Button>
    </StickyFooter>
  </ErrorLayout>
);

export default Error404;
